module.exports = __webpack_public_path__ + "static/media/tes-loading.d6895460.gif";